export {
  CookieConsentScript,
  useCookieConsent,
  CONSENT_CATEGORIES,
} from './services/cookie-consent';
